import React from "react";
import { cva } from "class-variance-authority";

import "./CardGrid.scss";

const cardGrid = cva("card-grid", {
    variants: {
        cols: {
            2: "cols-2",
            3: "cols-3",
            4: "cols-4",
        },
    },
});

type CardGridProps = {
    cols: 2 | 3 | 4;
};

export function CardGrid({
    children,
    cols,
}: React.PropsWithChildren<CardGridProps>) {
    const classes = cardGrid({ cols });

    return <div className={classes}>{children}</div>;
}
